.alabaster {
    background-color: var(--alabaster);
}

.blue {
    background-color: var(--blue);
    color: var(--white);
}

.white {
    background-color: var(--white);
}
